var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-menu"},[_c('TheHeaderNav',{staticClass:"mobile-menu__nav",attrs:{"items":_vm.nav,"mobile":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }